import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { locationChange } from '../../router/actions';
import type { CollectionPageAppState, ReorderQueueItem } from './types';

const initialState: CollectionPageAppState = {
  editSortMode: false,
  reorderQueue: [],
  flashHighlightIds: [],
};

export const collectionPageSlice = createSlice({
  name: 'collection',
  initialState,
  reducers: {
    setCollectionEditMode: (state, action: PayloadAction<boolean>) => {
      state.editSortMode = action.payload;
    },
    pushReorderQueueItem: (state, action: PayloadAction<ReorderQueueItem>) => {
      state.reorderQueue.push(action.payload);
    },
    clearReorderQueue: (state) => {
      state.reorderQueue = [];
    },
    setFlashHighlightIds: (state, action: PayloadAction<string[]>) => {
      state.flashHighlightIds = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(locationChange, (state) => {
      state.editSortMode = false;
      state.reorderQueue = [];
    });
  },
});

export const {
  setCollectionEditMode,
  pushReorderQueueItem,
  clearReorderQueue,
  setFlashHighlightIds,
} = collectionPageSlice.actions;

export const collectionPageReducer = collectionPageSlice.reducer;
